import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TerminalIntro = ({ onComplete }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const [isComplete, setIsComplete] = useState(false);
  
  const fullText = 'Hello there, welcome! Explore and learn a little more about me!';
  const typingSpeed = 80; // milliseconds per character
  const totalChars = fullText.length;
  const totalTypingTime = totalChars * typingSpeed; // ~6.4 seconds for 80 chars
  const pauseAfterTyping = 1500; // 1.5 seconds pause
  const fadeOutTime = 2000; // 2 seconds fade out
  
  useEffect(() => {
    let currentIndex = 0;
    
    // Typing effect
    const typingInterval = setInterval(() => {
      if (currentIndex < fullText.length) {
        setDisplayedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        
        // Wait before fading out
        setTimeout(() => {
          setIsComplete(true);
          
          // Complete and mark as seen
          setTimeout(() => {
            localStorage.setItem('hasSeenIntro', 'true');
            onComplete();
          }, fadeOutTime);
        }, pauseAfterTyping);
      }
    }, typingSpeed);
    
    // Cursor blink effect
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);
    
    return () => {
      clearInterval(typingInterval);
      clearInterval(cursorInterval);
    };
  }, [onComplete]);
  
  return (
    <div 
      className={`fixed inset-0 z-50 bg-black flex items-center justify-center transition-opacity duration-2000 ${
        isComplete ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="w-full max-w-4xl mx-4 p-6 md:p-8">
        {/* Terminal Window */}
        <div className="bg-gray-900 rounded-lg shadow-2xl border-2 border-green-500/30 overflow-hidden">
          {/* Terminal Header */}
          <div className="bg-gray-800 px-4 py-2 flex items-center gap-2 border-b border-green-500/30">
            <div className="flex gap-2">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
            <span className="text-green-400 text-sm font-mono ml-4">kushagra@portfolio:~</span>
          </div>
          
          {/* Terminal Content */}
          <div className="p-6 md:p-8 min-h-[200px] md:min-h-[250px] flex items-center">
            <div className="w-full">
              <div className="flex items-start mb-2">
                <span className="text-green-400 font-mono text-sm md:text-base mr-2">$</span>
                <div className="flex-1">
                  <p className="font-mono text-green-400 text-base md:text-xl leading-relaxed break-words">
                    {displayedText}
                    <span 
                      className={`inline-block w-2 h-5 md:h-6 ml-1 bg-green-400 ${
                        showCursor ? 'opacity-100' : 'opacity-0'
                      } transition-opacity`}
                      style={{ verticalAlign: 'middle' }}
                    ></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Retro scanline effect */}
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-green-500/5 to-transparent animate-scanline"></div>
      </div>
    </div>
  );
};

export default TerminalIntro;
